<template>
  <div>
    <h1>Associar Rota</h1>

    <div
      class="container-dados-usuario"
      v-if="
        (!loadingUsuario && listaDadosAssociados.length) ||
        listaDadosDisponiveis.length
      "
    >
      <h5>
        Grupo: <small> {{ usuarioGrupo.grupo }}</small>
      </h5>
    </div>

    <SGPAlertaComponent v-else />

    <SGPAssociarComponent
      v-if="listaDadosAssociados.length || listaDadosDisponiveis.length"
      tituloAssociados="Rotas"
      tituloDisponiveis="Rotas"
      :dadoAssociado="listaDadosAssociados"
      :dadoDisponivel="listaDadosDisponiveis"
      @sgpSalvarAssociacoesEmit="gruposParaAssociar"
    />

    <SGPLoadingComponent v-if="loadingUsuario" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "GrupoRotaAssociacaoPage",

  data() {
    return {
      listaDadosAssociados: [],
      listaDadosDisponiveis: [],
    };
  },

  async created() {
    await this.listarGrupos();
    await this.recuperarGrupoComRotas(this.$route.params.usuario);

    this.atualizarListaDeDadosAssociadosENaoAssociados();
  },

  computed: {
    ...mapGetters("gruposRotas", [
      "loadingUsuario",
      "listaGrupos",
      "grupoSelecionadoComRotas",
    ]),

    usuarioGrupo() {
      return this.grupoSelecionadoComRotas;
    },

    gruposAssociados() {
      return this.grupoSelecionadoComRotas.acl_rotas.map((rota) => {
        return {
          id: rota.id,
          descricao: rota.rota,
          selecionado: false,
        };
      });
    },

    gruposDisponiveis() {
      const listaDeGruposAssociados =
        this.grupoSelecionadoComRotas.acl_rotas.map((rota) => rota.id);
      console.log("grupos", this.listaGrupos);
      return this.listaGrupos
        .filter((rota) => {
          return !listaDeGruposAssociados.includes(rota.id);
        })
        .map((rota) => {
          return {
            id: rota.id,
            descricao: rota.rota,
            selecionado: false,
          };
        });
    },

    colunas() {
      return [
        {
          key: "grupo",
          label: "Nome",
          sortable: false,
        },
        {
          key: "redirecionar",
          label: "Rotas",
          sortable: false,
        },
      ];
    },
  },

  methods: {
    ...mapActions("grupos", ["listarUsuarios", "recuperarUsuario"]),
    ...mapActions("gruposRotas", [
      "listarGrupos",
      "recuperarGrupoComRotas",
      "associarRotaAoGrupo",
    ]),

    atualizarListaDeDadosAssociadosENaoAssociados() {
      this.listaDadosAssociados = this.gruposAssociados;
      this.listaDadosDisponiveis = this.gruposDisponiveis;
    },

    gruposParaAssociar(value) {
      const listaIdsAssociados = value.listaAssociados.map((rota) => {
        return rota.id;
      });

      const payload = {
        grupoId: this.$route.params.usuario,
        rotas: listaIdsAssociados,
      };

      this.associarRotaAoGrupo(payload);
    },
  },
};
</script>

